import React from 'react'

import { FormattedMessage, useIntl } from '@divvy-web/i18n'

import MarketingContent, { MarketingQuote } from '@sputnik/components/MarketingContent'

const ReviewFormMarketingContent = () => {
  const { formatMessage } = useIntl()

  return (
    <MarketingContent
      image={{
        alt: formatMessage({
          defaultMessage:
            'a top down view of two people looking at a laptop, with the person on the left holding a tablet while pointing to something on the laptop screen, all while the person on the right clasps their hands in contemplation',
          id: 'sputnik.ReviewFormMarketingContent__LSvEfr',
        }),
        src: 'https://app.divvy.co/assets/stock-photos/credit-application-review-and-sign-marketing-content.png',
        isRounded: true,
      }}
      pillText={
        <FormattedMessage
          defaultMessage='Testimonial'
          id='sputnik.ReviewFormMarketingContent__MvBefC'
        />
      }
    >
      <MarketingQuote
        designation={
          <FormattedMessage
            defaultMessage='CEO, HelpGood'
            id='sputnik.ReviewFormMarketingContent__gwzTpi'
          />
        }
        name={
          <FormattedMessage
            defaultMessage='Michael Bellavia'
            id='sputnik.ReviewFormMarketingContent__k7aWnN'
          />
        }
        quote={
          <FormattedMessage
            defaultMessage='“Spend & Expense has made communication with our bookkeeper, CPA, vendors, employees, and clients easier since we now have <strong>a single source of truth</strong>.”'
            id='sputnik.ReviewFormMarketingContent__n6hxW2'
            values={{
              strong: (chunk) => <b key='bold'>{chunk}</b>,
            }}
          />
        }
      />
    </MarketingContent>
  )
}

export default ReviewFormMarketingContent
